import { PageHeader } from '../components/ui/PageHeader.jsx';
import { ProfileForm } from '../components/account/ProfileForm.jsx';
import { PasswordForm } from '../components/account/PasswordForm.jsx';
import { MfaSection } from '../components/account/MfaSection.jsx';
import { PasskeySection } from '../components/account/PasskeySection.jsx';

/**
 * Account & security page used by every layout (admin, employee,
 * account). Contains profile data, password change, MFA enrolment
 * and a placeholder for future passkey support.
 */
export function AccountPage() {
  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Account e sicurezza"
        description="Gestisci i tuoi dati personali e le opzioni di sicurezza dell'account."
      />
      <ProfileForm />
      <PasswordForm />
      <MfaSection />
      <PasskeySection />
    </div>
  );
}
